import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';

import { getListsContaining } from '@/apis/lists';
import { labelSorting } from '@/util/labelSorting';
import { ListRecordResult } from '@/types/filterCriteriaRecords';

export const useLookupLists = () => {
  const { getAccessTokenSilently } = useAuth0();

  return useCallback(
    async (lookupValue: string) => {
      const token = await getAccessTokenSilently();
      const lists = (await getListsContaining({ token, containedString: lookupValue }))
        .map((x) => {
          return {
            id: x.id,
            label: x.name,
          } as ListRecordResult;
        })
        .sort(labelSorting);
      return lists;
    },
    [getAccessTokenSilently]
  );
};
